export enum EUpdateActions {
  Increment = 'increment',
  Decrement = 'decrement',
}
